import cn from "classnames";
import React, { ReactNode } from "react";
import { MAIN_LAYOUT_LOADING } from "../../constants/loading.constant";
import { LoadingSpinner } from "../component/LoadingSpinner";

interface Props {
  className?: string;
  children: ReactNode;
}

export default function Layout(props: Props) {
  const { className, children } = props;
  return (
    <>
      <LoadingSpinner
        size="lg"
        id={MAIN_LAYOUT_LOADING}
        style={{ top: "40%" }}
      />
      <div className={cn("d-flex flex-column w-100", className)}>{children}</div>
    </>
  );
}
